var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfilePic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h38v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6ABC69",
    stroke: "#FFF",
    strokeWidth: 3.003,
    d: "M19 17.6c7.732 0 14 6.268 14 14v2.886h0H5V31.6c0-7.732 6.268-14 14-14z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19,
    cy: 13.733,
    fill: "#5FB66F",
    stroke: "#FFF",
    strokeWidth: 3.003,
    rx: 8,
    ry: 7.733
  }))));
}
export default SvgIcProfilePic;